<div class="root flex-column">
  <div class="d-flex align-items-center">
    <label>
      <input
        type="checkbox"
        [(ngModel)]="checked"
        (ngModelChange)="onModelChange()"
        [id]="inputName()"
        [disabled]="disabled"
        [attr.aria-describedby]="inputName() + '-description'"
      />
      <span></span>
      <span *ngIf="labelText()">{{ labelText() }}</span>
      <span
        *ngIf="!labelText() && labelInnerHTML()"
        [innerHTML]="labelInnerHTML()"
      ></span>

      <span *ngIf="labelTemplate">
        <ng-container *ngTemplateOutlet="labelTemplate"></ng-container>
      </span>
    </label>

    <my-help
      *ngIf="helpTemplate"
      [tooltipPlacement]="helpPlacement()"
      helpType="custom"
    >
      <ng-template *ngTemplateOutlet="helpTemplate"></ng-template>
    </my-help>

    <div *ngIf="recommended()" class="ms-2 pt-badge badge-secondary" i18n>Recommended</div>
  </div>

  <div class="d-flex flex-column extra-container ms-4">
    <div class="wrapper form-group-description" [id]="inputName() + '-description'">
      <ng-content select="description"></ng-content>
    </div>

    <span class="wrapper mt-3">
      <ng-content select="extra"></ng-content>
    </span>
  </div>
</div>
